export const environment = {
  production: false,
  env: 'd.e.v',
  application: {
    clientId: 'af276465-2686-4a37-a6f0-7917ee9515d5',
    tenantId: 'd145d1f9-d198-4bfc-963d-1ebccb89af5b',
    redirectUri: 'https://myworkflow-dev.chill.ie',
    postLogoutRedirectUri: '/',
    api: {
      endpoint: '',
      scopes: ['api://e0f3be34-4c08-4c54-b656-537f572f03aa/.default'],
    },
  },
  defaultBrokerId: '01',
  brokerResolution: 'domain',
  brokers: {
    '01': {
      onboardingCampaignId: 35,
      onboardingSupportCampaignId: 36,
      onboardingNoEmailCampaignId: 37,
      agentsGroupId: '88b5f649-8cad-479e-9f04-8110f0fe33bf',
      ticketEmail: 'support@chilldev.atlassian.net',
    },
    '04': {
      // TODO: real Quote Devil campaign IDs
      onboardingCampaignId: 48,
      onboardingSupportCampaignId: 0,
      onboardingNoEmailCampaignId: 50,

      // TODO: real Quote Devil agents group id
      agentsGroupId: '967802b2-6123-4e74-b836-c5850f7464fe',
      ticketEmail: 'cstonell@quotedevil.ie, mciuciulete@quotedevil.ie, Admin@quotedevil.ie',
    },
  },

  eventStreamAPI: {
    address: 'https://workflowappstreamfunctions-uat.azurewebsites.net/',
    code: 'hbdkhplvi0FFNcUlVTqCwlqhhpjdwZP_Ghn60IHCPrrHAzFuLRZQ_g==',
    // address: 'https://mychillstreamfunctions-uat.azurewebsites.net/',
    // code: '8nNJ1VLp3XhVYuG0o04q9kKwZsRepGRmkutlVvMlBU4CAzFusEHKGA==',
  },

  apiManagement: {
    address: 'https://dev-api.chill.ie/mychill/dev/',
    subscriptionKey: 'b1dc8cbb656c41afaf515d719a7a14bf',
    webSocket: {
      address: 'https://url.chill.ie/dev',
      subscriptionKey: '1370ac63033543d7ae1040e0cbe8fb9f',
    },
  },
  graphAPI: {
    address: 'https://graph.microsoft.com/v1.0/groups',
  },
  ingestionAPI:
    'https://ca-api-ingestion.agreeableriver-b9cdfe4c.northeurope.azurecontainerapps.io/',
  onboardingAPI:
    'https://ca-api-onbording.agreeableriver-b9cdfe4c.northeurope.azurecontainerapps.io/',
};
